import { WompyPaymentMethod } from '@interfaces/shared';
import { environment } from '@environments/environment';

export function resolveWompyPublicKey(method: WompyPaymentMethod = 'card'): string {
  return environment.wompyKeys[method] ?? environment.wompyKeys.card;
}
